import React from "react";

// Shared input class + labeled Field wrapper for the B2B form.
export const inputCls =
  "w-full px-4 py-3 rounded-xl border border-black/15 bg-white focus:outline-none focus:ring-2 focus:ring-[#2CBFCF] focus:border-[#2CBFCF] text-neutral-900 placeholder:text-neutral-400 transition-all";

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="block text-xs font-semibold uppercase tracking-widest text-neutral-500 mb-2">
        {label}
      </span>
      {children}
    </label>
  );
}
